import { render, staticRenderFns } from "./dialog-view-rename.vue?vue&type=template&id=6213243a&scoped=true"
import script from "./dialog-view-rename.vue?vue&type=script&lang=js"
export * from "./dialog-view-rename.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6213243a",
  null
  
)

export default component.exports